"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpTextType = exports.PTextLightType = exports.PTextType = void 0;
var PTextType;
(function (PTextType) {
    PTextType["LEAD"] = "lead";
    PTextType["LEAD_V2"] = "leadV2";
    PTextType["VALUE"] = "value";
    PTextType["VALUE_V2"] = "valueV2";
    PTextType["SMALL"] = "small";
    PTextType["XSMALL"] = "xsmall";
})(PTextType = exports.PTextType || (exports.PTextType = {}));
var PTextLightType;
(function (PTextLightType) {
    PTextLightType["LEAD"] = "lead";
    PTextLightType["VALUE"] = "value";
})(PTextLightType = exports.PTextLightType || (exports.PTextLightType = {}));
var HelpTextType;
(function (HelpTextType) {
    HelpTextType["DEFAULT"] = "default";
    HelpTextType["SUCCESS"] = "success";
    HelpTextType["ERROR"] = "error";
})(HelpTextType = exports.HelpTextType || (exports.HelpTextType = {}));
